<template>
  <div class="page-wrapper">
    <!-- 顶部标题 + 课程选择 -->
    <el-header class="page-header">
      <div class="table-header-box">
        <div class="section-title">错题房</div>
        <el-select
          v-model="errorCourseSerial"
          placeholder="请选择课程"
          size="small"
          @change="onErrorCourseChange"
          :disabled="errorCourseOptions.length === 0"
          class="course-select"
        >
          <el-option
            v-for="course in errorCourseOptions"
            :key="course.serialnumber"
            :label="course.catalog"
            :value="course.serialnumber"
          ></el-option>
        </el-select>
      </div>
    </el-header>

    <!-- 主体：表格 + 分页 -->
    <el-main class="page-main">
      <div class="table-container">
        <el-table
          :data="errorTableData"
          height="100%"
          stripe
          :border="false"
          v-loading="errorLoading"
          element-loading-text="正在加载数据..."
          :header-cell-style="{
            background: '#f8fafc',
            color: '#475569',
            fontWeight: 'bold'
          }"
          style="width: 100%"
        >
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{ scope.row.displayIndex }}
            </template>
          </el-table-column>
          <el-table-column prop="knowledgeName" label="知识点" min-width="140">
          </el-table-column>
          <el-table-column label="题目" min-width="420">
            <template slot-scope="scope">
              <div v-if="scope.row.listQuestion" class="error-question-stem">
                <div
                  v-for="(range, idx) in scope.row.listQuestion.steam"
                  :key="`stem-${scope.row.displayIndex}-${idx}`"
                >
                  <span
                    v-for="(item, n) in range.wordInfos"
                    :key="`stem-word-${idx}-${n}`"
                  >
                    <span v-if="item.wdType === 1" v-katex
                      >${{ item.latex }}$</span
                    >
                    <img v-else-if="item.wdType === 2" :src="item.buffer" />
                    <span v-else>{{ item.content }}</span>
                  </span>
                </div>
              </div>
              <div v-else class="error-question-fallback">题干缺失</div>
            </template>
          </el-table-column>
          <el-table-column label="难易度" width="90" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="levelTagType(scope.row.level)">
                {{ levelLabel(scope.row.level) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="题型" width="90" align="center">
            <template slot-scope="scope">
              {{ qtypeLabel(scope.row.qtype) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="errorTypeName"
            label="类型"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column label="创建时间" width="160" align="center">
            <template slot-scope="scope">
              {{ formatTime(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="280" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="action-btn"
                @click="openErrorAnalysis(scope.row)"
                :disabled="!scope.row.fullQuestion"
              >
                解析
              </el-button>
              <el-button
                type="text"
                size="small"
                class="action-btn"
                @click="startErrorPractice(scope.row)"
              >
                练习
              </el-button>
              <el-button
                type="text"
                size="small"
                class="action-btn"
                @click="startErrorExpand(scope.row)"
              >
                扩展练习
              </el-button>
              <el-button
                type="text"
                size="small"
                class="action-btn"
                @click="openErrorAttachment(scope.row)"
                :disabled="!hasAttachment(scope.row)"
              >
                附件
              </el-button>
            </template>
          </el-table-column>
          <template slot="empty">
            <el-empty description="休息一下，目前没有错题记录"></el-empty>
          </template>
        </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          background
          :current-page="errorPagination.pageNumber"
          :page-size="errorPagination.pageSize"
          :page-sizes="[10, 20, 30, 50]"
          layout="total, sizes, prev, pager, next"
          :total="errorPagination.total"
          @size-change="onErrorPageSizeChange"
          @current-change="onErrorPageChange"
        >
        </el-pagination>
      </div>
    </el-main>
    <!-- 解析弹窗（增强版） -->
    <el-dialog
      title="错题解析"
      :visible.sync="errorDialogVisible"
      width="70%"
      destroy-on-close
    >
      <div
        v-if="errorDialogQuestion"
        :key="
          'analysis-' +
            (errorDialogQuestion.id || errorDialogQuestion.qid || '')
        "
        class="error-question-dialog"
      >
        <!-- 题干 -->
        <div class="error-question-stem">
          <div
            v-for="(range, idx) in errorDialogQuestion.steam"
            :key="`dialog-stem-${idx}`"
          >
            <span
              v-for="(item, n) in range.wordInfos"
              :key="`dialog-stem-word-${idx}-${n}`"
            >
              <span v-if="item.wdType === 1" v-katex>${{ item.latex }}$</span>
              <img v-else-if="item.wdType === 2" :src="item.buffer" />
              <span v-else>{{ item.content }}</span>
            </span>
          </div>
        </div>

        <!-- 学生答案 -->
        <div class="student-answer-row">
          <span class="student-answer-label">学生答案：</span>
          <span class="student-answer-value"
            >&nbsp;{{
              resolveStudentAnswer(errorDialogSourceRow, errorDialogQuestion)
            }}</span
          >
        </div>

        <!-- 选项（单选/多选） -->
        <div
          v-if="
            errorDialogQuestion &&
              (errorDialogQuestion.qtype === 'SingX' ||
                errorDialogQuestion.subjectType === 'SingX' ||
                errorDialogQuestion.qtype === 'MultX' ||
                errorDialogQuestion.subjectType === 'MultX')
          "
          class="error-dialog-options"
        >
          <div
            v-for="(op, idx) in errorDialogQuestion.options"
            :key="'dialog-op-' + idx"
            :class="[
              'option-row',
              { 'student-selected': isStudentSelected(idx) }
            ]"
          >
            <span class="option-code"
              >{{ "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[idx] }}.</span
            >
            <span
              v-for="(range, rIdx) in op.ranginfos"
              :key="'op-range-' + idx + '-' + rIdx"
            >
              <span
                v-for="(item, n) in range.wordInfos"
                :key="'op-word-' + idx + '-' + rIdx + '-' + n"
              >
                <span v-if="item.wdType === 1" v-katex>${{ item.latex }}$</span>
                <img v-else-if="item.wdType === 2" :src="item.buffer" />
                <span v-else>{{ item.content }}</span>
              </span>
            </span>
            <span v-if="isOptionCorrect(op)" class="correct-flag"
              >&nbsp;&nbsp;✓正确答案</span
            >
          </div>
        </div>

        <!-- 解析区 -->
        <div
          v-if="
            errorDialogShowSolve &&
              ((errorDialogQuestion.solve &&
                errorDialogQuestion.solve.length) ||
                (errorDialogQuestion.slove && errorDialogQuestion.slove.length))
          "
          class="error-question-solve"
        >
          <div class="error-question-section-title">【解析:】</div>
          <div
            v-for="(range, idx) in errorDialogQuestion.solve &&
            errorDialogQuestion.solve.length
              ? errorDialogQuestion.solve
              : errorDialogQuestion.slove"
            :key="`dialog-solve-${idx}`"
          >
            <span
              v-for="(item, n) in range.wordInfos"
              :key="`dialog-solve-word-${idx}-${n}`"
            >
              <span v-if="item.wdType === 1" v-katex>${{ item.latex }}$</span>
              <img v-else-if="item.wdType === 2" :src="item.buffer" />
              <span v-else>{{ item.content }}</span>
            </span>
          </div>
        </div>
      </div>
      <div slot="footer" class="analysis-dialog-footer">
        <el-button @click="errorDialogVisible = false">关闭</el-button>
        <el-button
          type="primary"
          @click="errorDialogShowSolve = !errorDialogShowSolve"
        >
          {{ errorDialogShowSolve ? "隐藏解析" : "查看解析" }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 练习弹窗 -->
    <el-dialog
      :title="
        currentPracticeQuestion
          ? currentPracticeQuestion.qtypename || '练习'
          : '练习'
      "
      :visible.sync="errorPracticeVisible"
      width="60%"
      :close-on-click-modal="false"
      destroy-on-close
      custom-class="practice-dialog-wrapper"
    >
      <div
        v-loading="errorPracticeLoading"
        class="error-practice-dialog"
        :key="
          'practice-' +
            errorPracticeIndex +
            '-' +
            (currentPracticeQuestion
              ? currentPracticeQuestion.id || currentPracticeQuestion.qid || ''
              : '')
        "
      >
        <template v-if="currentPracticeQuestion">
          <!-- 题干 -->
          <div class="practice-stem-wrapper">
            <div class="error-question-stem practice-stem">
              <div
                v-for="(range, idx) in currentPracticeQuestion.steam"
                :key="`practice-stem-${idx}`"
              >
                <span
                  v-for="(item, n) in range.wordInfos"
                  :key="`practice-stem-word-${idx}-${n}`"
                >
                  <span v-if="item.wdType === 1" v-katex
                    >${{ item.latex }}$</span
                  >
                  <img v-else-if="item.wdType === 2" :src="item.buffer" />
                  <span v-else>{{ item.content }}</span>
                </span>
              </div>
            </div>
          </div>

          <!-- 单选/多选作答（统一用 checkbox 样式） -->
          <div
            v-if="
              currentPracticeQuestion.subjectType === 'SingX' ||
                currentPracticeQuestion.qtype === 'SingX' ||
                currentPracticeQuestion.subjectType === 'MultX' ||
                currentPracticeQuestion.qtype === 'MultX'
            "
            class="practice-options"
          >
            <div
              v-for="(op, idx) in currentPracticeQuestion.options"
              :key="'practice-choice-' + idx"
              :class="[
                'practice-option-item',
                { 'practice-option-selected': isPracticeOptionSelected(idx) }
              ]"
              @click="togglePracticeOption(idx)"
            >
              <span
                :class="[
                  'practice-checkbox-square',
                  { 'is-checked': isPracticeOptionSelected(idx) }
                ]"
              ></span>
              <span class="option-code"
                >{{ "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[idx] }}.</span
              >
              <span class="option-content">
                <span
                  v-for="(range, rIdx) in op.ranginfos"
                  :key="'pco-range-' + idx + '-' + rIdx"
                >
                  <span
                    v-for="(item, n) in range.wordInfos"
                    :key="'pco-word-' + idx + '-' + rIdx + '-' + n"
                  >
                    <span v-if="item.wdType === 1" v-katex
                      >${{ item.latex }}$</span
                    >
                    <img v-else-if="item.wdType === 2" :src="item.buffer" />
                    <span v-else>{{ item.content }}</span>
                  </span>
                </span>
              </span>
            </div>
          </div>

          <!-- 判断题作答 -->
          <div
            v-else-if="
              currentPracticeQuestion.subjectType === 'JudgX' ||
                currentPracticeQuestion.qtype === 'JudgX'
            "
            class="practice-options"
          >
            <el-radio-group
              :value="errorPracticeAnswers[currentPracticeQid()]"
              @input="setPracticeAnswer($event)"
            >
              <el-radio label="正确">正确</el-radio>
              <el-radio label="错误">错误</el-radio>
            </el-radio-group>
          </div>

          <!-- 填空/解答/证明：文本输入 -->
          <div v-else class="practice-options">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入你的答案"
              :value="errorPracticeAnswers[currentPracticeQid()] || ''"
              @input="setPracticeAnswer($event)"
            ></el-input>
          </div>

          <!-- 解析区域（提交后可展示） -->
          <div
            v-if="
              errorPracticeShowSolve &&
                errorPracticeSubmitted[currentPracticeQid()]
            "
            class="practice-solve-area"
          >
            <div class="error-question-section-title">【解析:】</div>
            <div
              v-if="
                (currentPracticeQuestion.solve &&
                  currentPracticeQuestion.solve.length) ||
                  (currentPracticeQuestion.slove &&
                    currentPracticeQuestion.slove.length)
              "
            >
              <div
                v-for="(range, idx) in currentPracticeQuestion.solve &&
                currentPracticeQuestion.solve.length
                  ? currentPracticeQuestion.solve
                  : currentPracticeQuestion.slove"
                :key="`practice-solve-${idx}`"
              >
                <span
                  v-for="(item, n) in range.wordInfos"
                  :key="`practice-solve-word-${idx}-${n}`"
                >
                  <span v-if="item.wdType === 1" v-katex
                    >${{ item.latex }}$</span
                  >
                  <img v-else-if="item.wdType === 2" :src="item.buffer" />
                  <span v-else>{{ item.content }}</span>
                </span>
              </div>
            </div>
            <div v-else class="no-solve-tip">暂无解析</div>
          </div>
        </template>
        <el-empty v-else description="暂无练习题"></el-empty>
      </div>
      <div slot="footer" class="practice-footer">
        <div class="practice-footer-right">
          <el-button
            size="small"
            :disabled="errorPracticeIndex <= 0"
            @click="prevPracticeQuestion"
            >&lt; 上一题</el-button
          >
          <el-button
            size="small"
            :disabled="errorPracticeIndex >= errorPracticeList.length - 1"
            @click="nextPracticeQuestion"
            >下一题 &gt;</el-button
          >
          <el-button
            size="small"
            :disabled="!!errorPracticeSubmitted[currentPracticeQid()]"
            @click="submitPracticeAnswer"
            >提交答案</el-button
          >
          <el-button
            size="small"
            type="success"
            :disabled="!errorPracticeSubmitted[currentPracticeQid()]"
            @click="togglePracticeSolve"
            >{{ errorPracticeShowSolve ? "隐藏解析" : "查看解析" }}</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog title="附件" :visible.sync="errorAttachmentVisible" width="40%">
      <div v-if="errorAttachmentList.length === 0">暂无附件</div>
      <div v-else class="error-attachment-list">
        <div
          v-for="(item, index) in errorAttachmentList"
          :key="index"
          class="error-attachment-item"
        >
          <el-link
            v-if="attachmentUrl(item)"
            :href="attachmentUrl(item)"
            target="_blank"
          >
            {{ attachmentName(item) }}
          </el-link>
          <span v-else>{{ attachmentName(item) }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCourseByStudent } from "@/api/course";
import {
  pageErrorQuestionList,
  getQuestionListByErrorQuestionId
} from "@/api/question";
import { saveCorrectionRecord } from "@/api/questionPractice";
import { convertToFullQuestion } from "@/util/extraction";
import { getQuestionsByIds } from "@/api/student";

export default {
  name: "ErrQuestionsIndex",
  data() {
    return {
      errorCourseOptions: [],
      errorCourseSerial: "",
      errorTableData: [],
      errorLoading: false,
      // 解析弹窗
      errorDialogVisible: false,
      errorDialogQuestion: null,
      errorDialogSourceRow: null,
      errorDialogShowSolve: true,
      // 附件弹窗
      errorAttachmentVisible: false,
      errorAttachmentList: [],
      // 练习弹窗
      errorPracticeVisible: false,
      errorPracticeLoading: false,
      errorPracticeList: [],
      errorPracticeIndex: 0,
      errorPracticeAnswers: {},
      errorPracticeSubmitted: {},
      errorPracticeShowSolve: false,
      errorPracticeSourceRow: null,
      errorPracticeType: 1,
      errorPracticeQuestionStartedAt: 0,
      // 分页
      errorPagination: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  computed: {
    currentPracticeQuestion() {
      return this.errorPracticeList[this.errorPracticeIndex] || null;
    }
  },
  mounted() {
    this.guardAndInit();
  },
  methods: {
    async guardAndInit() {
      this.initErrorRoom();
    },
    async initErrorRoom() {
      await this.loadErrorCourseOptions();
      if (this.errorCourseSerial) {
        this.errorPagination.pageNumber = 1;
        await this.fetchErrorQuestionList();
      }
    },
    async loadErrorCourseOptions() {
      try {
        const res = await getCourseByStudent();
        if (res.code === 200) {
          this.errorCourseOptions = res.data || [];
          if (this.errorCourseOptions.length > 0 && !this.errorCourseSerial) {
            this.errorCourseSerial = this.errorCourseOptions[0].serialnumber;
          }
        } else {
          this.errorCourseOptions = [];
          this.errorCourseSerial = "";
          this.$message.error(res.message || "课程加载失败");
        }
      } catch (error) {
        this.errorCourseOptions = [];
        this.errorCourseSerial = "";
        this.$message.error("课程加载失败");
      }
    },
    async fetchErrorQuestionList() {
      if (!this.errorCourseSerial) {
        this.errorTableData = [];
        this.errorPagination.total = 0;
        return;
      }
      this.errorLoading = true;
      try {
        const res = await pageErrorQuestionList({
          courseSerialnumber: this.errorCourseSerial,
          pageSize: this.errorPagination.pageSize,
          pageNumber: this.errorPagination.pageNumber
        });
        if (res.code === 200) {
          const pageData = res.data || {};
          const records = pageData.records || [];
          this.errorPagination.total = pageData.total || 0;
          this.errorPagination.pageNumber =
            pageData.current || this.errorPagination.pageNumber;
          this.errorPagination.pageSize =
            pageData.size || this.errorPagination.pageSize;
          this.errorTableData = records.map((item, index) =>
            this.buildErrorRow(item, index)
          );
        } else {
          this.errorTableData = [];
          this.errorPagination.total = 0;
          this.$message.error(res.message || "错题加载失败");
        }
      } catch (error) {
        this.errorTableData = [];
        this.errorPagination.total = 0;
        this.$message.error("错题加载失败");
      } finally {
        this.errorLoading = false;
      }
    },
    buildErrorRow(row, index) {
      let errorAnswer = row.errorAnswer;
      let order = "";
      if (typeof errorAnswer === "string" && errorAnswer.includes("#")) {
        const parts = errorAnswer.split("#");
        errorAnswer = parts[0];
        order = parts[1];
      }
      const processedRow = { ...row, errorAnswer, order };

      const displayIndex =
        (this.errorPagination.pageNumber - 1) * this.errorPagination.pageSize +
        index +
        1;
      const fullQuestion = this.buildErrorQuestionEntity(processedRow);
      let listQuestion = null;
      if (fullQuestion) {
        fullQuestion.index = displayIndex;
        listQuestion = {
          steam: fullQuestion.steam || []
        };
      }
      return {
        ...processedRow,
        displayIndex,
        listQuestion,
        fullQuestion
      };
    },
    buildErrorQuestionEntity(row, onlyStem = true) {
      try {
        const payload = {
          ...row
        };
        payload.hasLatex =
          payload.hasLatex === undefined ? payload.haslatex : payload.hasLatex;
        payload.knowledgeID =
          payload.knowledgeID || payload.knowledgeSerialnumber;
        // 传递解析出的 order 供 convertToFullQuestion 使用
        if (row.order) {
          payload.order = row.order;
        }
        return convertToFullQuestion(payload, onlyStem);
      } catch (error) {
        return null;
      }
    },
    hasAnalysisDetails(question) {
      if (!question) return false;
      const hasOptions =
        Array.isArray(question.options) && question.options.length > 0;
      const hasSolve =
        (Array.isArray(question.solve) && question.solve.length > 0) ||
        (Array.isArray(question.slove) && question.slove.length > 0);
      return hasOptions || hasSolve;
    },
    async loadAnalysisQuestionDetail(row) {
      // 优先尝试用当前行数据做完整转换
      const localDetail = this.buildErrorQuestionEntity(row, false);
      if (this.hasAnalysisDetails(localDetail)) {
        return localDetail;
      }

      const questionId = row.questionId || row.id;
      if (!questionId) {
        return localDetail || row.fullQuestion;
      }

      try {
        const res = await getQuestionsByIds([questionId]);
        const list = Array.isArray(res && res.data) ? res.data : [];
        if (list.length > 0) {
          const payload = {
            ...list[0]
          };
          payload.hasLatex =
            payload.hasLatex === undefined
              ? payload.haslatex
              : payload.hasLatex;
          payload.knowledgeID =
            payload.knowledgeID || payload.knowledgeSerialnumber;
          return convertToFullQuestion(payload, false);
        }
      } catch (error) {
        // ignore and fallback to local parsed result
      }
      return localDetail || row.fullQuestion;
    },
    onErrorCourseChange() {
      this.errorPagination.pageNumber = 1;
      this.fetchErrorQuestionList();
    },
    onErrorPageChange(page) {
      this.errorPagination.pageNumber = page;
      this.fetchErrorQuestionList();
    },
    onErrorPageSizeChange(size) {
      this.errorPagination.pageSize = size;
      this.errorPagination.pageNumber = 1;
      this.fetchErrorQuestionList();
    },
    levelLabel(level) {
      if (level === 1) return "易";
      if (level === 2) return "中";
      if (level === 3) return "难";
      return "-";
    },
    levelTagType(level) {
      if (level === 1) return "success";
      if (level === 2) return "warning";
      if (level === 3) return "danger";
      return "info";
    },
    qtypeLabel(qtype) {
      if (!qtype) return "-";
      const val = String(qtype).trim();
      const map = {
        SingX: "单选题",
        MultX: "多选题",
        JudgeX: "判断题",
        JudgX: "判断题",
        FillX: "填空题",
        AnwsX: "简答题",
        ProofX: "证明题",
        单选: "单选题",
        多选: "多选题",
        判断: "判断题"
      };
      // 优先匹配映射表（原样匹配）
      if (map[val]) return map[val];

      // 容错处理：不区分大小写匹配
      const upperVal = val.toUpperCase();
      for (const key in map) {
        if (key.toUpperCase() === upperVal) return map[key];
      }

      // 容错处理：如果已经是“单选”但没在表里，补齐“题”字
      if (["单选", "多选", "判断", "填空", "简答", "证明"].includes(val)) {
        return val + "题";
      }
      return val;
    },
    formatTime(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }
      const pad = num => (num < 10 ? `0${num}` : `${num}`);
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
    async openErrorAnalysis(row) {
      if (!row || !row.fullQuestion) {
        this.$message.info("暂无解析");
        return;
      }
      this.errorDialogSourceRow = row;
      this.errorDialogQuestion = row.fullQuestion;
      this.errorDialogShowSolve = true;
      this.errorDialogVisible = true;

      // 若列表仅包含题干数据，补拉完整题目详情（含选项与解析）
      if (!this.hasAnalysisDetails(this.errorDialogQuestion)) {
        const detail = await this.loadAnalysisQuestionDetail(row);
        if (detail) {
          this.errorDialogQuestion = detail;
          this.$set(row, "fullQuestion", detail);
        }
      }
    },
    resolveStudentAnswer(row, question) {
      if (!row) return "未作答";
      let raw = row.errorAnswer;
      if (typeof raw === "string" && raw.includes("#")) {
        raw = raw.split("#")[0];
      }
      if (raw === "" || raw === null || raw === undefined) return "未作答";
      const CODES = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const isChoice =
        question &&
        (question.qtype === "SingX" ||
          question.subjectType === "SingX" ||
          question.qtype === "MultX" ||
          question.subjectType === "MultX");
      if (isChoice) {
        // errorAnswer 为数字索引（0=A,1=B,2=C,3=D）或逗号分隔的多个索引
        const arr = Array.isArray(raw)
          ? raw
          : String(raw)
              .split(",")
              .map(s => s.trim())
              .filter(Boolean);
        return arr
          .map(v => {
            const originalIndex = Number(v);
            if (!isNaN(originalIndex) && question.options) {
              // 找到原始索引为 originalIndex 的选项在当前物理列表中的索引
              const physicalIndex = question.options.findIndex(
                opt => opt.index == originalIndex
              );
              if (physicalIndex !== -1 && physicalIndex < 26) {
                return CODES[physicalIndex];
              }
            }
            // 兜底：如果没找到（比如旧数据没有 index 属性），则按原逻辑
            const num = Number(v);
            if (!isNaN(num) && num >= 0 && num < 26) {
              return CODES[num];
            }
            return String(v);
          })
          .sort()
          .join(",");
      }
      // 判断题：0=正确，1=错误（或根据实际值兼容）
      const isJudge =
        question &&
        (question.qtype === "JudgX" || question.subjectType === "JudgX");
      if (isJudge) {
        if (raw === 1 || raw === "1" || raw === true || raw === "true")
          return "正确";
        if (raw === 0 || raw === "0" || raw === false || raw === "false")
          return "错误";
      }
      return String(raw);
    },
    isOptionCorrect(option) {
      return !!(option && option.correct);
    },
    isStudentSelected(physicalIndex) {
      const row = this.errorDialogSourceRow;
      const question = this.errorDialogQuestion;
      if (!row || !question) return false;
      let raw = row.errorAnswer;
      if (typeof raw === "string" && raw.includes("#")) {
        raw = raw.split("#")[0];
      }
      if (raw === "" || raw === null || raw === undefined) return false;
      const arr = Array.isArray(raw)
        ? raw
        : String(raw)
            .split(",")
            .map(s => s.trim())
            .filter(Boolean);

      const currentOption = question.options && question.options[physicalIndex];
      if (currentOption && currentOption.index !== undefined) {
        // 判断当前这个物理位置的选项，其原始索引是否在学生的答案中
        return arr.some(v => Number(v) === currentOption.index);
      }
      // 兜底：如果没找到 index 属性，退回到原逻辑
      return arr.some(v => Number(v) === physicalIndex);
    },
    async startErrorPractice(row) {
      if (!row) return;
      this.errorPracticeSourceRow = row;
      this.errorPracticeType = 1;
      this.errorPracticeLoading = true;
      try {
        const res = await getQuestionListByErrorQuestionId({
          questionId: row.questionId || row.id,
          type: 1,
          level: row.level,
          qtype: row.qtype,
          courseSerialnumber: row.courseSerialnumber || this.errorCourseSerial,
          knowledgeSerialnumber: row.knowledgeSerialnumber
        });
        if (
          res.code !== 200 ||
          !Array.isArray(res.data) ||
          res.data.length === 0
        ) {
          this.$message.info(res.message || "暂无可练习题目");
          return;
        }
        this.errorPracticeList = res.data.map(item => {
          const payload = {
            ...item,
            hasLatex:
              item.hasLatex === undefined ? item.haslatex : item.hasLatex,
            knowledgeID: item.knowledgeID || item.knowledgeSerialnumber
          };
          return convertToFullQuestion(payload, false);
        });
        this.errorPracticeIndex = 0;
        this.errorPracticeAnswers = {};
        this.errorPracticeSubmitted = {};
        this.errorPracticeShowSolve = false;
        this.errorPracticeVisible = true;
        this.markPracticeQuestionStart();
      } catch (e) {
        this.$message.error("练习题加载失败");
      } finally {
        this.errorPracticeLoading = false;
      }
    },
    async startErrorExpand(row) {
      if (!row) return;
      this.errorPracticeSourceRow = row;
      this.errorPracticeType = 2;
      this.errorPracticeLoading = true;
      try {
        const res = await getQuestionListByErrorQuestionId({
          questionId: row.questionId || row.id,
          type: 2, // 扩展练习类型为 2
          level: row.level, // 使用当前题目的难度等级
          qtype: row.qtype,
          courseSerialnumber: row.courseSerialnumber || this.errorCourseSerial,
          knowledgeSerialnumber: row.knowledgeSerialnumber
        });

        if (
          res.code !== 200 ||
          !Array.isArray(res.data) ||
          res.data.length === 0
        ) {
          this.$message.info(res.message || "暂无可扩展练习题目");
          return;
        }

        // 复用练习的数据处理逻辑
        this.errorPracticeList = res.data.map(item => {
          const payload = {
            ...item,
            hasLatex:
              item.hasLatex === undefined ? item.haslatex : item.hasLatex,
            knowledgeID: item.knowledgeID || item.knowledgeSerialnumber
          };
          return convertToFullQuestion(payload, false);
        });

        // 重置练习状态
        this.errorPracticeIndex = 0;
        this.errorPracticeAnswers = {};
        this.errorPracticeSubmitted = {};
        this.errorPracticeShowSolve = false;

        // 打开练习弹窗（标题逻辑会自动处理为"扩展练习"或题目类型）
        // 为了区分，如果需要特定标题可以在这里设置一个临时变量，但目前的逻辑复用 currentPracticeQuestion.qtypename 已经足够好。
        // 如果想强制显示“扩展练习”，可以修改模板中的 title 逻辑，或者仅让它显示题型。
        this.errorPracticeVisible = true;
        this.markPracticeQuestionStart();
      } catch (e) {
        console.error(e);
        this.$message.error("扩展练习加载失败");
      } finally {
        this.errorPracticeLoading = false;
      }
    },
    prevPracticeQuestion() {
      if (this.errorPracticeIndex > 0) {
        this.errorPracticeIndex--;
        this.errorPracticeShowSolve = false;
        this.markPracticeQuestionStart();
      }
    },
    nextPracticeQuestion() {
      if (this.errorPracticeIndex < this.errorPracticeList.length - 1) {
        this.errorPracticeIndex++;
        this.errorPracticeShowSolve = false;
        this.markPracticeQuestionStart();
      }
    },
    setPracticeAnswer(val) {
      const q = this.currentPracticeQuestion;
      if (!q) return;
      const qid = q.id || q.qid || this.errorPracticeIndex;
      this.$set(this.errorPracticeAnswers, qid, val);
    },
    async submitPracticeAnswer() {
      const q = this.currentPracticeQuestion;
      if (!q) return;
      const qid = this.currentPracticeQid();
      const answer = this.errorPracticeAnswers[qid];
      if (this.isPracticeAnswerEmpty(answer)) {
        this.$message.info("请先作答再提交");
        return;
      }

      // 答案比对逻辑
      let isCorrect = null;
      const qtype = this.getPracticeQuestionTypeCode(q);
      const isChoice = qtype === "SingX" || qtype === "MultX";
      const isJudge = qtype === "JudgX" || qtype === "JudgeX";

      if (isChoice) {
        // 获取所有正确选项的字母代码（如 ["A", "C"]）
        const correctCodes = (q.options || [])
          .map((op, idx) =>
            op.correct ? "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[idx] : null
          )
          .filter(Boolean);

        if (Array.isArray(answer)) {
          // 多选：数量一致且内容一致
          isCorrect =
            answer.length === correctCodes.length &&
            answer.every(v => correctCodes.includes(v)) &&
            correctCodes.every(v => answer.includes(v));
        } else {
          // 单选：直接比对
          isCorrect = correctCodes.length === 1 && correctCodes[0] === answer;
        }
      } else if (isJudge) {
        // 判断题：answer 为 "正确"/"错误"
        // 使用 q.judge 进行比对（1 为正确，0 为错误）
        const correctVal =
          q.judge === 1 || q.judge === "1" || q.judge === true
            ? "正确"
            : "错误";
        isCorrect = answer === correctVal;
      }

      this.$set(this.errorPracticeSubmitted, qid, true);

      // 根据结果弹出对应的提示
      if (isCorrect === true) {
        this.$message({
          message: "您的答案完全正确！",
          type: "success",
          duration: 3000
        });
      } else if (isCorrect === false) {
        this.$message({
          message: "您的答案错了！",
          type: "error",
          duration: 3000
        });
      } else {
        this.$message({
          message: "答案已提交",
          type: "success",
          duration: 3000
        });
      }

      try {
        await this.persistCorrectionRecord(q, answer, isCorrect);
      } catch (e) {
        this.$message.warning("改错记录保存失败，但答题结果已判定");
      }
    },
    togglePracticeSolve() {
      const q = this.currentPracticeQuestion;
      if (!q) return;
      const qid = q.id || q.qid || this.errorPracticeIndex;
      if (!this.errorPracticeSubmitted[qid]) {
        this.$message.info("请先提交答案再查看解析");
        return;
      }
      this.errorPracticeShowSolve = !this.errorPracticeShowSolve;
    },
    currentPracticeQid() {
      const q = this.currentPracticeQuestion;
      return q ? q.id || q.qid || this.errorPracticeIndex : null;
    },
    markPracticeQuestionStart() {
      this.errorPracticeQuestionStartedAt = Date.now();
    },
    getPracticeAnswerCostMillis() {
      if (!this.errorPracticeQuestionStartedAt) {
        return null;
      }
      const cost = Date.now() - this.errorPracticeQuestionStartedAt;
      return cost > 0 ? cost : null;
    },
    isPracticeAnswerEmpty(answer) {
      if (answer === null || answer === undefined) return true;
      if (Array.isArray(answer)) return answer.length === 0;
      if (typeof answer === "string") return answer.trim() === "";
      return false;
    },
    normalizePracticeStudentAnswer(question, answer) {
      const qtype = this.getPracticeQuestionTypeCode(question);
      if (qtype === "MultX") {
        return Array.isArray(answer) ? [...answer].sort() : [];
      }
      if (qtype === "SingX") {
        return typeof answer === "string" ? answer : String(answer || "");
      }
      if (qtype === "JudgX") {
        if (
          answer === true ||
          answer === "true" ||
          answer === 1 ||
          answer === "1"
        )
          return true;
        if (
          answer === false ||
          answer === "false" ||
          answer === 0 ||
          answer === "0"
        )
          return false;
        return answer === "正确";
      }
      return typeof answer === "string" ? answer : String(answer || "");
    },
    getPracticeQuestionTypeCode(question) {
      const raw = (question && (question.subjectType || question.qtype)) || "";
      const map = {
        SingX: "SingX",
        MultX: "MultX",
        JudgX: "JudgX",
        JudgeX: "JudgX",
        FillX: "FillX",
        AnwsX: "AnwsX",
        ProofX: "ProofX",
        单选题: "SingX",
        多选题: "MultX",
        判断题: "JudgX",
        填空题: "FillX",
        解答题: "AnwsX",
        证明题: "ProofX"
      };
      return map[raw] || raw || "All";
    },
    resolvePracticeQuestionOrder(question) {
      const order = question && (question.questionOrder || question.order);
      if (order || order === 0) {
        return Number(order) || 0;
      }
      return this.errorPracticeIndex + 1;
    },
    resolvePracticeCourseSerialnumber(question) {
      return (
        (question && question.courseSerialnumber) ||
        (this.errorPracticeSourceRow &&
          this.errorPracticeSourceRow.courseSerialnumber) ||
        this.errorCourseSerial ||
        ""
      );
    },
    resolvePracticeKnowledgeSerialnumber(question) {
      return (
        (question && question.knowledgeSerialnumber) ||
        (this.errorPracticeSourceRow &&
          this.errorPracticeSourceRow.knowledgeSerialnumber) ||
        ""
      );
    },
    async persistCorrectionRecord(question, answer, isCorrect) {
      const sourceQuestionId = Number(
        (this.errorPracticeSourceRow &&
          (this.errorPracticeSourceRow.questionId ||
            this.errorPracticeSourceRow.id)) ||
          0
      );
      const questionId = Number(
        (question && (question.id || question.qid)) || 0
      );
      const courseSerialnumber = this.resolvePracticeCourseSerialnumber(
        question
      );
      const knowledgeSerialnumber = this.resolvePracticeKnowledgeSerialnumber(
        question
      );
      if (
        !sourceQuestionId ||
        !questionId ||
        !courseSerialnumber ||
        !knowledgeSerialnumber
      ) {
        throw new Error("缺少改错记录关键字段");
      }
      const payload = {
        courseSerialnumber,
        knowledgeSerialnumber,
        sourceQuestionId,
        questionId,
        practiceType: this.errorPracticeType || 1,
        qtype: this.getPracticeQuestionTypeCode(question),
        questionOrder: this.resolvePracticeQuestionOrder(question),
        studentAnswer: JSON.stringify(
          this.normalizePracticeStudentAnswer(question, answer)
        ),
        isCorrect: typeof isCorrect === "boolean" ? (isCorrect ? 1 : 0) : null,
        costMillis: this.getPracticeAnswerCostMillis()
      };
      await saveCorrectionRecord(payload);
    },
    isPracticeOptionSelected(idx) {
      const qid = this.currentPracticeQid();
      const answer = this.errorPracticeAnswers[qid];
      if (!answer && answer !== 0) return false;
      const code = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[idx];
      if (Array.isArray(answer)) return answer.includes(code);
      return answer === code;
    },
    togglePracticeOption(idx) {
      const q = this.currentPracticeQuestion;
      if (!q) return;
      const qid = this.currentPracticeQid();
      const code = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[idx];
      const isMulti = q.subjectType === "MultX" || q.qtype === "MultX";
      if (isMulti) {
        const current = this.errorPracticeAnswers[qid] || [];
        const arr = Array.isArray(current) ? [...current] : [];
        const pos = arr.indexOf(code);
        if (pos >= 0) {
          arr.splice(pos, 1);
        } else {
          arr.push(code);
        }
        this.$set(this.errorPracticeAnswers, qid, arr);
      } else {
        // 单选：点击已选则取消，否则选中
        const current = this.errorPracticeAnswers[qid];
        this.$set(this.errorPracticeAnswers, qid, current === code ? "" : code);
      }
    },
    hasAttachment(row) {
      return row && Array.isArray(row.attachment) && row.attachment.length > 0;
    },
    attachmentName(item) {
      return (
        item.name || item.fileName || item.filename || item.title || "附件"
      );
    },
    attachmentUrl(item) {
      return item.url || item.fileUrl || item.path || item.filePath || "";
    },
    openErrorAttachment(row) {
      if (!this.hasAttachment(row)) {
        this.$message.info("暂无附件");
        return;
      }
      this.errorAttachmentList = row.attachment || [];
      this.errorAttachmentVisible = true;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/examination-page.scss";

/* ===== 错题房页面专属布局（遵循风格.md规范） ===== */

.page-wrapper {
  background-color: #f5f7fa;
  height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
  gap: 16px;
}

.page-header {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 15px 20px !important;
  height: auto !important;
  flex-shrink: 0;

  .table-header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
  }

  .section-title {
    font-size: 18px;
    font-weight: 800;
    color: #1e293b;
    position: relative;
    padding-left: 12px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 18px;
      background: #2563eb;
      border-radius: 2px;
    }
  }

  .course-select {
    width: 200px;
  }
}

.page-main {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px !important;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}

.table-container {
  flex: 1;
  overflow: hidden;
}

.pagination-container {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

/* 操作列文字按钮 */
.action-btn {
  font-size: 14px;
  padding: 0 4px;
}
</style>
